import { createUseStyles } from 'react-jss'

import config from 'styles/config'
import { textSize, color, boldFont } from '@portal/kit/pkg/styles'
import { withRanIcon, ranIcon, withDesktopRanIcon, desktopRanIcon } from 'styles/helpers'

const ranRoomCardStyles = createUseStyles(theme => ({
  devicesButton: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    cursor: 'pointer',
    paddingRight: 25,
    backgroundColor: 'transparent',
    borderRadius: 0,
    ...color('textDefault'),
    ...withRanIcon(),

    '& strong': {
      ...boldFont(),
    },
  },
  devicesButtonIcon: {
    ...ranIcon(theme),
  },
  devicesButtonArrow: {
    position: 'absolute',
    fontSize: 14,
    right: 4,
    transitionDuration: '200ms',
    transformOrigin: 'center',
  },
  devicesButtonArrowUp: {
    transform: 'rotate(180deg)'
  },
  deviceList: {
    paddingTop: 18,

    '& table': {
      width: '100%',
      marginBottom: 24,
    },
    '& th': {
      paddingBottom: 6,
      ...boldFont(),
      ...color('textSecondary'),
      ...textSize(14, 19),
      textAlign: 'left',
      borderBottom: '1px solid rgba(150, 150, 150, 0.1)',
    },
    '& td': {
      paddingTop: 6,
      ...textSize(14, 19)
    },
  },
  deviceListDesktopOnly: {
    display: 'none',
  },
  noDevices: {
    ...color('textSecondary'),
    textAlign: 'center'
  },
  resetSection: {
    textAlign: 'right'
  },
  [config.mediaQueries.tabletPortrait]: {
    devicesButton: {
      ...withDesktopRanIcon(),
    },
    devicesButtonIcon: {
      ...desktopRanIcon(),
    },
    devicesButtonArrow: {
      right: 10,
    },
    deviceListDesktopOnly: {
      display: 'table-cell',
    },
  }
}))

export default ranRoomCardStyles
